export default __webpack_public_path__ + "static/media/dash_book_appointment.89797767.svg";